export default {
  updatedPassword: '',
  __typename: 'FindPasswordSuccess'
};
